import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-black/5 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="container py-6">
        <div className="flex items-center justify-between">
          {/* Logo - Simple Text Only */}
          <Link to="/" className="flex items-center">
            <span className="text-xl font-[var(--font-display)] tracking-tight text-foreground">Ellis Row</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            <Link to="/" className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors">
              Home
            </Link>
            <Link to="/units" className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors">
              Units
            </Link>
            <Link to="/contact" className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors">
              Contact
            </Link>
          </div>

          <div className="hidden md:block">
            <Link to="/units">
              <Button
                data-testid="nav-primary-cta-button"
                size="sm"
                className="bg-[#121416] text-white hover:bg-[#1B1F24] rounded-md px-6 font-medium"
              >
                View Units
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="nav-mobile-menu-button"
            className="md:hidden text-foreground"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden mt-4 py-4 border-t border-border"
          >
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                Home
              </Link>
              <Link to="/units" className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                Units
              </Link>
              <Link to="/contact" className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                Contact
              </Link>
            </div>
          </motion.div>
        )}
      </div>
    </nav>
  );
}